import React from 'react';
import Icon from '../../../components/AppIcon';

const IndustryStats = () => {
  const stats = [
    {
      id: 1,
      icon: "Building2",
      value: "50+",
      label: "Industry Projects",
      description: "Successful transformations across verticals"
    },
    {
      id: 2,
      icon: "Users",
      value: "35+",
      label: "Enterprise Clients",
      description: "Fortune 500 and mid-market leaders"
    },
    {
      id: 3,
      icon: "TrendingUp",
      value: "2.5x",
      label: "Average ROI",
      description: "Measurable business impact delivered"
    },
    {
      id: 4,
      icon: "Shield",
      value: "100%",
      label: "Compliance Rate",
      description: "Meeting regulatory requirements"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-headline text-foreground mb-4">
            Industry Impact by the Numbers
          </h2>
          <p className="text-base md:text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            Proven track record of delivering transformative solutions across complex industries
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats?.map((stat) => (
            <div
              key={stat?.id}
              className="bg-card rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 text-center border border-border"
            >
              <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name={stat?.icon} size={28} className="text-primary" />
              </div>
              <div className="text-3xl md:text-4xl font-bold text-primary font-headline mb-2">
                {stat?.value}
              </div>
              <div className="text-base md:text-lg font-semibold text-foreground font-headline mb-2">
                {stat?.label}
              </div>
              <p className="text-sm text-muted-foreground font-body">
                {stat?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustryStats;